import React from "react";
import PropTypes from "prop-types";
import { Card, Icon } from "@weezevent/nacre";
import Style from "./empty-table.module.scss";

export const EmptyTableContext = {
	SEARCH: "search",
	NO_RESULTS: "no_results"
};

// this think is over-abstracted, we can't just concatenate the `label` inside static phrases, it only (barely) works in english
// "Aucun intégration"
// "Vous n'avez pas d'scan"
const EmptyTable = ({ title, subtitle, createButtonLabel, to, context }) => {
	return (
		<Card className={Style["empty"]}>
			<Card.EmptyState
				icon={<Icon name="list" />}
				title={title}
				subtitle={subtitle}
				labelButton={
					to && context === EmptyTableContext.NO_RESULTS
						? createButtonLabel
						: undefined
				}
				to={to}
			/>
		</Card>
	);
};

EmptyTable.propTypes = {
	title: PropTypes.string.isRequired,
	subtitle: PropTypes.string.isRequired,
	createButtonLabel: PropTypes.string,
	to: PropTypes.func,
	context: PropTypes.oneOf(Object.keys(EmptyTableContext)).isRequired
};

EmptyTable.defaultProps = {
	createButtonLabel: "",
	to: null
};

export default EmptyTable;
